<template>
  <div>
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">Ano Letivo
            <span v-if="choices.aaletivo">
              {{ choices.aaletivo }}
            </span>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2">Nível de Ensino
            <span v-if="choices.cdinstruc">
              {{ itemEscolhidos('cdinstruc', 'dsinstruc') }}
            </span>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 3" step="3">Etapa Escolar
            <span v-if="step >= 3">
              {{ itemEscolhidos('cdserie', 'dsserie') }}
            </span>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 4" :editable="step > 4" step="4">Disciplina
            <span v-if="step >= 4" :title="itemEscolhidos('cddiscipl', 'dsdiscipl')" class="busca-text-step">
              {{ itemEscolhidos('cddiscipl', 'dsdiscipl') }}
            </span>
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <!-- Ano letivo -->
            <form @submit.prevent="getNivel">
              <div class="mb-2">
                <div v-if="options.aaletivo.length > 0">
                  <Radio v-for="ano in options.aaletivo" name="ano" :key="ano.id" v-model.number="choices.aaletivo" :label="ano" :val="ano"/>
                </div>
                <span v-else>
                  Nenhuma ano letivo encontrado.
                </span>
              </div>
              <v-btn
                class="rounded-sm font-weight-regular"
                :disabled="!choices.aaletivo || loading"
                type="submit"
                color="primary"
                :loading="loading">
              Continuar</v-btn>
            </form>
          </v-stepper-content>
          <!-- Nivel -->
          <v-stepper-content step="2">
            <form @submit.prevent="getEtapa">
              <div class="mb-2">
                <div v-if="options.cdinstruc.length > 0">
                  <Radio v-for="nivel in options.cdinstruc" name="ano" :key="nivel.id" v-model.number="choices.cdinstruc" :label="`${nivel.cdinstruc} - ${nivel.dsinstruc}`" :val="nivel.cdinstruc"/>
                </div>
                <span v-else>
                  Nenhum nível de ensino encontrado.
                </span>
              </div>
              <v-btn
                :disabled="!choices.cdinstruc || loading"
                color="primary"
                type="submit"
                :loading="loading"
                class=" rounded-sm font-weight-regular me-2 me-2"
              >Continuar</v-btn>
              <v-btn class="rounded-sm font-weight-regular" @click="back('cdinstruc')">Voltar</v-btn>
            </form>
          </v-stepper-content>
          <!-- Etapa Escolar -->
          <v-stepper-content step="3">
            <form @submit.prevent="getDisciplina">
              <div class="mb-2">
                <div v-if="options.cdserie.length > 0">
                  <Radio v-for="etapa in options.cdserie" name="ano" :key="etapa.id" v-model.number="choices.cdserie" :label="etapa.dsserie" :val="etapa.cdserie"/>
                </div>
                <span v-else>
                  Nenhuma etapa escolar encontrada.
                </span>
              </div>
              <v-btn class="rounded-sm font-weight-regular me-2" color="primary" type="submit" :disabled="(!choices.cdserie && options.cdserie.length < 0) || loading" :loading="loading">Confirmar</v-btn>
              <v-btn class="rounded-sm font-weight-regular" @click="back('cdserie')">Voltar</v-btn>
            </form>
          </v-stepper-content>
          <!-- Disciplina -->
          <v-stepper-content step="4">
            <form @submit.prevent="confirm">
              <div class="mb-2">
                <div v-if="options.cddiscipl.length > 0">
                  <Radio v-for="disciplina in options.cddiscipl" name="ano" :key="disciplina.id" v-model.number="choices.cddiscipl" :label="disciplina.dsdiscipl" :val="disciplina.cddiscipl"/>
                </div>
                <span v-else>
                  Nenhuma disciplina encontrada.
                </span>
              </div>
              <v-btn class="me-2 rounded-sm font-weight-regular" color="success" type="submit">Confirmar</v-btn>
              <v-btn class="rounded-sm font-weight-regular" @click="back('cddiscipl')">Voltar</v-btn>
            </form>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
  </div>
</template>

<script>
import api from '@/api';
import _ from 'lodash';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const DisciplinaRepository = RepositoryFactory.get('disciplina');

export default {
  name: 'BuscaAnoNivelEtapaDisciplina',
  data() {
    return  {
      options: {
        aaletivo: [],
        cdinstruc: [],
        cdserie: [],
        cddiscipl: [],
      },
      choices: {
        aaletivo: null,
        cdinstruc: null,
        cdserie: null,
        cddiscipl: null,
      },
      step: 1,
      loading: false,
    };
  },
  created() {
    this.getAno();
  },
  watch: {
    step(newVal, oldVal) {
      if(newVal == 4 && oldVal > 4) { this.$emit('reloading'); }
    },
  },
  methods: {
    confirm() {
      let aux = { ...this.choices };
      if(aux.cdserie === null) {
        aux.cdserie = this.options.cdserie.map(key => parseInt(key.cdserie));
        aux.cdserie.shift();
      } else {
        aux.cdserie = [ this.choices.cdserie ];
      }
      this.$emit('chosen', aux);
      this.step = 5;
    },
    back(choice) {
      this.step--;
      this.choices[choice] = null;
    },
    async get(resource) {
      const { data } = await api.get(`ei/${resource}`);
      return data.results;
    },
    async getAno() {
      this.loading = true;
      const data = await this.get('grade/anosletivos?take=5');
      this.options.aaletivo = data.map(key => key.aaletivo);
      this.loading = false;
    },
    async getNivel(){
      this.loading = true;
      const anoescolhido = this.choices.aaletivo;
      const data = await this.get(`grade/nivelensino?aaletivo=${anoescolhido}`);
      this.options.cdinstruc = data.map(key => ({ cdinstruc: key.cdinstruc, dsinstruc: key.nivel.dsinstruc, }));
      this.options.cdinstruc = _.orderBy(this.options.cdinstruc, 'dsinstruc', 'asc');
      this.step = 2;
      this.loading = false;
    },
    async getEtapa(){
      this.loading = true;
      this.options.cdserie = await this.get(`distribuirnotas/etapaescolar?cdinstruc=${this.choices.cdinstruc}`);
      if( this.options.cdserie.length > 0) {
        this.options.cdserie = _.orderBy(this.options.cdserie, 'dsserie', 'asc');
        this.options.cdserie.unshift({ cdserie: null, dsserie: 'TODOS' });
      }
      this.step = 3;
      this.loading = false;
    },
    async getDisciplina() {
      this.loading = true;
      try {
        // this.options.cddiscipl = [{ cddiscipl: null, dsdiscipl: 'TODOS' }];
        this.options.cddiscipl = [];

        const { data } = await DisciplinaRepository.getSelectDisciplinaConceito({
          aaletivo: this.choices.aaletivo,
          cdinstruc: this.choices.cdinstruc,
          cdserie: this.choices.cdserie,
        });

        this.options.cddiscipl = [
          ...this.options.cddiscipl,
          ...data.results.map(key => ({ cddiscipl: key.cddiscipl, dsdiscipl: key.dsdiscipl })),
        ];
        this.step = 4;
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    itemEscolhidos() {
      return (campo, desc) => {
        const descricao = this.options[campo].find(key => key[campo] == this.choices[campo]);
        return (descricao) ? descricao[desc] : '';
      };
    },
  },
}
</script>

<style lang="scss" scope>
.busca-text-step {
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
